import { StyledContent } from './styles';
import { ContentProps } from './types';

export const Content = ({ children, ...props }: ContentProps) => {
    const id = 'main-content-title';

    return (
        <StyledContent role="main" aria-labelledby={id} {...props}>
            {children}
        </StyledContent>
    );
};
